/* Swipe to close (Oct 5).

   iPhone-style dismiss gestures for every pop-over on the site:

     - Portfolio full-screen view (all gallery pages): drag down and the
       drawing follows your finger, shrinking slightly while the dark
       background fades. Let go far enough (or flick) and it closes;
       otherwise it springs back. Disabled while zoomed in so panning still
       works, and never starts on the email sign-up box.
     - Menu drawer: swipe it back toward the edge it came from.
     - Cart drawer and other side drawers: swipe toward the edge they slid
       in from.
     - Search and other pop-up windows: swipe down (only when their content
       is scrolled to the top, so normal scrolling is never hijacked).

   The direction is worked out from where each panel actually sits on the
   screen, so a drawer that slides in from the left closes with a left swipe
   and one from the right closes with a right swipe.

   Gestures are ignored when they start in a text field, inside something
   that scrolls sideways (like the "available on" card row when swiping a
   drawer), or on anything marked data-no-swipe-close. Two fingers always
   cancel, so pinch-zoom is untouched.

   Closing always goes through each component's own close (button, close()
   or closeDialog()), so focus, scroll position and page locking are
   restored exactly as they are when the X is tapped. */
(function () {
  'use strict';
  if (window.__swipeToClose) return;
  window.__swipeToClose = true;

  var LOCK = 10;        // px of movement before deciding what the gesture is
  var RATIO = 1.15;     // close axis must beat the other axis by this much
  var FLICK = 0.5;      // px per ms that counts as a flick
  var g = null;         // gesture in progress
  var suppressClickUntil = 0;

  var style = document.createElement('style');
  style.textContent =
    '[data-lightbox].active{touch-action:none;}' +
    '[data-lightbox].active [data-lightbox-available-row]{touch-action:pan-x;}' +
    '[data-lightbox].active [data-lightbox-signup]{touch-action:manipulation;}' +
    'header-drawer details[open] .menu-drawer,theme-drawer dialog[open]{touch-action:pan-y pinch-zoom;}';
  document.head.appendChild(style);

  function vw() { return window.innerWidth; }
  function vh() { return window.innerHeight; }

  function inTextField(el) {
    return !!el.closest('input, textarea, select, [contenteditable="true"], [data-no-swipe-close]');
  }

  function imgScale(img) {
    var m = (img.style.transform || '').match(/scale\(([\d.]+)\)/);
    return m ? parseFloat(m[1]) : 1;
  }

  function sideOf(rect) {
    if (rect.left <= 2) return 'left';
    if (rect.right >= vw() - 2) return 'right';
    return 'down';
  }

  function findTarget(el) {
    // 1. Portfolio full-screen view
    var lb = el.closest('[data-lightbox]');
    if (lb && lb.classList.contains('active')) {
      if (el.closest('[data-lightbox-signup], [data-lightbox-close], [data-lightbox-prev], [data-lightbox-next]')) return null;
      var img = lb.querySelector('[data-lightbox-img]');
      if (img && imgScale(img) > 1.05) return null;
      var stage = lb.querySelector('[data-lightbox-stage]');
      if (!stage) return null;
      return {
        kind: 'lightbox',
        root: lb,
        panel: stage,
        dir: 'down',
        extras: ['[data-lightbox-available]', '[data-lightbox-close]', '[data-lightbox-prev]', '[data-lightbox-next]']
          .map(function (s) { return lb.querySelector(s); }).filter(Boolean),
        close: function () { var b = lb.querySelector('[data-lightbox-close]'); if (b) b.click(); }
      };
    }

    // 2. Menu drawer
    var details = el.closest('header-drawer details[open]');
    if (details) {
      var host = details.closest('header-drawer');
      var panel = host && host.querySelector('details[open] .menu-drawer');
      if (panel && typeof host.close === 'function') {
        var side = sideOf(panel.getBoundingClientRect());
        return {
          kind: 'drawer',
          root: host.querySelector('details[open]'),
          panel: panel,
          dir: side,
          extras: [],
          close: function () { host.close(); },
          doneEvent: 'toggle'
        };
      }
    }

    // 3. Cart drawer, side drawers, search and other pop-up windows
    var dlg = el.closest('dialog[open]');
    if (dlg) {
      var closer = null;
      var td = dlg.closest('theme-drawer');
      if (td && typeof td.close === 'function') {
        closer = function () { td.close(); };
      } else {
        for (var n = dlg.parentElement; n; n = n.parentElement) {
          if (typeof n.closeDialog === 'function') {
            closer = (function (c) { return function () { c.closeDialog(); }; })(n);
            break;
          }
        }
      }
      if (!closer) {
        closer = function () {
          var b = dlg.querySelector('.theme-drawer__close-button, [aria-label*="close" i], [data-close]');
          if (b) b.click(); else dlg.close();
        };
      }
      return {
        kind: 'dialog',
        root: dlg,
        panel: dlg,
        dir: sideOf(dlg.getBoundingClientRect()),
        extras: [],
        close: closer,
        doneEvent: 'close'
      };
    }
    return null;
  }

  // Would this touch be better spent scrolling something?
  function blockedByScroller(el, t) {
    for (var n = el; n; n = n.parentElement) {
      if (n.nodeType !== 1) continue;
      var cs = window.getComputedStyle(n);
      if (t.dir === 'down') {
        if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') && n.scrollHeight > n.clientHeight + 1 && n.scrollTop > 0) return true;
      } else {
        if ((cs.overflowX === 'auto' || cs.overflowX === 'scroll') && n.scrollWidth > n.clientWidth + 1) return true;
      }
      if (n === t.root) break;
    }
    return false;
  }

  function primary(dx, dy, dir) {
    if (dir === 'down') return { p: dy, s: dx };
    if (dir === 'left') return { p: -dx, s: dy };
    return { p: dx, s: dy };
  }

  function offset(d, dir) {
    if (dir === 'down') return 'translate3d(0,' + d + 'px,0)';
    if (dir === 'left') return 'translate3d(' + (-d) + 'px,0,0)';
    return 'translate3d(' + d + 'px,0,0)';
  }

  function size(t) {
    if (t.kind === 'lightbox') return vh();
    var r = t.panel.getBoundingClientRect();
    return t.dir === 'down' ? Math.min(r.height, vh()) : r.width;
  }

  function render(t, d) {
    if (t.kind === 'lightbox') {
      var k = Math.min(d / vh(), 1);
      var fade = Math.min(d / (vh() * 0.45), 1);
      t.panel.style.transform = 'translate3d(0,' + d + 'px,0) scale(' + (1 - k * 0.14) + ')';
      t.root.style.backgroundColor = 'rgba(0,0,0,' + (0.94 * (1 - fade * 0.8)).toFixed(3) + ')';
      var o = Math.max(0, 1 - fade * 1.6).toFixed(3);
      t.extras.forEach(function (x) { x.style.opacity = o; });
    } else {
      t.panel.style.transform = offset(d, t.dir);
    }
  }

  function setTransition(t, value) {
    t.panel.style.transition = value;
    if (t.kind === 'lightbox') {
      t.root.style.transition = value ? value.replace('transform', 'background-color') : '';
      t.extras.forEach(function (x) { x.style.transition = value ? value.replace('transform', 'opacity') : ''; });
    }
  }

  function clear(t) {
    t.panel.style.transform = '';
    t.panel.style.transition = '';
    t.panel.style.visibility = '';
    t.panel.style.willChange = '';
    if (t.kind === 'lightbox') {
      t.root.style.backgroundColor = '';
      t.root.style.transition = '';
      t.extras.forEach(function (x) { x.style.opacity = ''; x.style.transition = ''; });
    }
  }

  function snapBack(t) {
    setTransition(t, 'transform .3s cubic-bezier(.22,1,.36,1)');
    render(t, 0);
    setTimeout(function () { clear(t); }, 320);
  }

  function dismiss(t, v) {
    var dist = size(t) + 40;
    var ms = Math.max(140, Math.min(260, Math.round((dist - (t.d || 0)) / Math.max(v, 1.4))));
    setTransition(t, 'transform ' + ms + 'ms cubic-bezier(.3,.7,.4,1)');
    if (t.kind === 'lightbox') {
      t.panel.style.transform = 'translate3d(0,' + vh() + 'px,0) scale(.86)';
      t.root.style.backgroundColor = 'rgba(0,0,0,0)';
      t.extras.forEach(function (x) { x.style.opacity = '0'; });
    } else {
      t.panel.style.transform = offset(dist, t.dir);
    }

    setTimeout(function () {
      suppressClickUntil = 0;
      if (t.kind === 'lightbox') {
        t.close();
        clear(t);
        return;
      }
      // Hide the panel, then let the component run its own close so focus,
      // scrolling and page locking are restored. Tidy up once it has closed.
      t.panel.style.visibility = 'hidden';
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        t.root.removeEventListener(t.doneEvent, finish);
        clear(t);
      }
      t.root.addEventListener(t.doneEvent, finish);
      setTimeout(finish, 1200);
      t.close();
    }, ms);
  }

  window.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) {
      if (g && g.engaged) snapBack(g.t);
      g = null;
      return;
    }
    var el = e.target;
    if (!el || el.nodeType !== 1 || inTextField(el)) return;
    var t = findTarget(el);
    if (!t || blockedByScroller(el, t)) return;
    var touch = e.touches[0];
    g = { t: t, x0: touch.clientX, y0: touch.clientY, engaged: false, off: 0, samples: [] };
  }, { capture: true, passive: true });

  window.addEventListener('touchmove', function (e) {
    if (!g) return;
    if (e.touches.length !== 1) {
      if (g.engaged) snapBack(g.t);
      g = null;
      return;
    }
    var touch = e.touches[0];
    var a = primary(touch.clientX - g.x0, touch.clientY - g.y0, g.t.dir);

    if (!g.engaged) {
      // A downward pull can only ever bounce the page, so claim it straight
      // away; that keeps iOS from turning it into a rubber-band scroll.
      if (g.t.dir === 'down' && a.p > 0 && a.p >= Math.abs(a.s) && e.cancelable) e.preventDefault();
      if (Math.abs(a.p) < LOCK && Math.abs(a.s) < LOCK) return;
      if (a.p > 0 && a.p > Math.abs(a.s) * RATIO) {
        g.engaged = true;
        g.off = a.p;
        g.t.panel.style.willChange = 'transform';
        setTransition(g.t, '');
      } else {
        g = null; // not ours: let it scroll or swipe sideways as normal
        return;
      }
    }

    if (e.cancelable) e.preventDefault();
    var d = Math.max(0, a.p - g.off);
    g.t.d = d;
    render(g.t, d);
    var now = Date.now();
    g.samples.push({ d: d, at: now });
    while (g.samples.length > 2 && now - g.samples[0].at > 100) g.samples.shift();
  }, { capture: true, passive: false });

  function end(e) {
    if (!g) return;
    if (e.touches && e.touches.length) return; // another finger still down
    var cur = g;
    g = null;
    if (!cur.engaged) return;
    suppressClickUntil = Date.now() + 350;
    var d = cur.t.d || 0;
    var s = cur.samples;
    var v = 0;
    if (s.length > 1) {
      var first = s[0], last = s[s.length - 1];
      v = (last.d - first.d) / Math.max(1, last.at - first.at);
    }
    var need = cur.t.kind === 'lightbox' ? vh() * 0.14 : size(cur.t) * 0.3;
    var commit = e.type !== 'touchcancel' && (d > need || (v > FLICK && d > 30));
    if (commit) dismiss(cur.t, v); else snapBack(cur.t);
  }
  window.addEventListener('touchend', end, { capture: true, passive: true });
  window.addEventListener('touchcancel', end, { capture: true, passive: true });

  // A drag that springs back must not count as a tap on the dark backdrop.
  window.addEventListener('click', function (e) {
    if (Date.now() < suppressClickUntil) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, true);
})();
